/* Colour siblings inside the quick view.
   The theme's quickview handler will not re-render while a modal is already open, so a
   colour click inside the popup did nothing. Close the open modal first, then replay the
   click on a detached anchor carrying the same href/data-id the handler reads. */
(function () {
  if (window.__mkCsQv) return;
  window.__mkCsQv = true;

  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('.mk-cs__item[data-action-quickview]');
    if (!a) return;
    var inModal = a.closest('.t4s-product-quick-view, .t4s-modal');
    if (!inModal) return;                       // on a product page the plain link is right

    e.preventDefault();
    e.stopPropagation();

    var url = a.getAttribute('href');
    var id  = a.getAttribute('data-id');
    if (!url || !id) return;

    var close = document.querySelector('.t4s-modal--is-active .t4s-modal-close, .t4s-modal--is-active .mfp-close, .mfp-close');
    if (close) close.click();

    setTimeout(function () {
      var t = document.createElement('a');
      t.href = url;
      t.setAttribute('data-action-quickview', '');
      t.setAttribute('data-id', id);
      t.setAttribute('rel', 'nofollow');
      t.style.cssText = 'position:absolute;left:-9999px;';
      document.body.appendChild(t);
      if (window.jQuery) window.jQuery(t).trigger('click'); else t.click();
      setTimeout(function () { t.parentNode && t.parentNode.removeChild(t); }, 200);
    }, 380);
  }, true);
})();
